import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_property_favorite_overlay = _resolveComponent("o-property-favorite-overlay")!
  const _component_portal = _resolveComponent("portal")!

  return ($options.showSearchFavoritePropertyOverlay)
    ? (_openBlock(), _createBlock(_component_portal, {
        key: 0,
        to: "modal"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_o_property_favorite_overlay, {
            redirected: $props.redirected,
            "redirected-from": $props.redirectedFrom,
            texts: $props.texts,
            consent: $props.consent
          }, null, 8 /* PROPS */, ["redirected", "redirected-from", "texts", "consent"])
        ], undefined, true),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}